var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row offers mt-2"
  }, [_c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h3', {
    staticClass: "h3 text-center pt-1"
  }, [_vm._v("Premium Offers")]), _c('div', {
    staticClass: "row justify-content-end mb-1"
  }, [_c('span', {
    staticClass: "pr-2"
  }, [_c('router-link', {
    staticClass: "btn btn-sm btn-dark",
    attrs: {
      "to": {
        name: _vm.PremiumCreatePath.name
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1), _c('span', [_c('button', {
    staticClass: "btn btn-sm btn-dark",
    on: {
      "click": _vm.actionGetOffers
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])]), _c('div', {
    staticClass: "col-sm-auto"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v(" Count : "), _c('strong', {
    staticClass: "pl-2"
  }, [_vm._v(" " + _vm._s(_vm.totalRows) + " ")])])])]), _c('b-table', {
    attrs: {
      "responsive": "",
      "items": _vm.items,
      "fields": _vm.fields,
      "busy": _vm.isLoading,
      "isLoading": _vm.isLoading,
      "tbody-tr-class": _vm.rowClass,
      "show-empty": "",
      "hover": "",
      "striped": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc
    },
    on: {
      "update:sortBy": function ($event) {
        _vm.sortBy = $event;
      },
      "update:sort-by": function ($event) {
        _vm.sortBy = $event;
      },
      "update:sortDesc": function ($event) {
        _vm.sortDesc = $event;
      },
      "update:sort-desc": function ($event) {
        _vm.sortDesc = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function () {
        return [_c('div', {
          staticClass: "text-center text-dark my-2"
        }, [_c('b-spinner', {
          staticClass: "align-middle",
          attrs: {
            "variant": "dark",
            "type": "grow",
            "label": "Loading .."
          }
        }), _vm._v(" Loading .. ")], 1)];
      },
      proxy: true
    }, {
      key: "head()",
      fn: function (row) {
        return [_c('div', {
          staticClass: "text-nowrap"
        }, [_vm._v(" " + _vm._s(row.label) + " ")])];
      }
    }, {
      key: "cell(No)",
      fn: function (row) {
        return [_vm._v(" " + _vm._s((_vm.currentPage - 1) * _vm.perPage + (row.index + 1)) + " ")];
      }
    }, {
      key: "cell(offers)",
      fn: function (row) {
        return [_vm._v(" " + _vm._s(_vm.OfferType(row.item.offer_type_id)) + " ")];
      }
    }, {
      key: "cell(name)",
      fn: function (row) {
        return [_c('router-link', {
          staticClass: "btn btn-sm btn-success",
          attrs: {
            "to": {
              name: _vm.PremiumItemPath.name,
              params: {
                id: row.item.id
              }
            }
          }
        }, [_vm._v(" " + _vm._s(row.item.name) + " ")]), _c('strong', [_vm._v(" #" + _vm._s(row.item.id))])];
      }
    }, {
      key: "cell(discount)",
      fn: function (row) {
        return [_vm._v(" " + _vm._s(row.item.discount_id) + " ")];
      }
    }, {
      key: "cell(priceidr)",
      fn: function (row) {
        return [_vm._v(" " + _vm._s(_vm.formatPrice(row.item.price_idr, 'IDR')) + " ")];
      }
    }, {
      key: "cell(priceusd)",
      fn: function (row) {
        return [_vm._v(" " + _vm._s(_vm.formatPrice(row.item.price_usd, 'USD')) + " ")];
      }
    }, {
      key: "cell(offer_status)",
      fn: function (row) {
        return [_c('div', {
          staticStyle: {
            "min-width": "100px"
          }
        }, [_vm._v(" " + _vm._s(_vm.OfferStatus(row.item.offer_status)) + " ")])];
      }
    }, {
      key: "cell(is_free)",
      fn: function (row) {
        return [_c('div', [row.item.is_free ? _c('span', {
          staticClass: "badge badge-success"
        }, [_vm._v(" Y ")]) : _c('span', {
          staticClass: "badge badge-danger"
        }, [_vm._v(" N ")])])];
      }
    }, {
      key: "cell(action_edit)",
      fn: function (row) {
        return [_c('router-link', {
          staticClass: "btn btn-default",
          attrs: {
            "to": {
              name: _vm.PremiumEditPath.name,
              params: {
                id: row.item.id
              }
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-edit"
        })])];
      }
    }, {
      key: "cell(action_detail)",
      fn: function (row) {
        return [_c('router-link', {
          staticClass: "btn btn-default",
          attrs: {
            "target": "_blank",
            "to": {
              name: _vm.PremiumDetail.name,
              params: {
                id: row.item.id
              }
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-eye"
        })])];
      }
    }])
  })], 1), _c('b-row', {
    staticClass: "justify-content-start ml-1"
  }, [_c('b-col', {
    attrs: {
      "lg": "3"
    }
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "aria-controls": "my-table"
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }